// utils/format.js
/**
 * Sanitize numeric input — allow dynamic decimal precision
 * Format number as currency with commas + 2 decimals
 * Sanitize input: only allow digits, commas, decimals.
 * If invalid, fallback to last valid number.
 */
/**
 */
export function sanitizeNumberInput(value, prevValue = "", decimals = 2) {
  if (!value) return "";

  // Keep only digits, commas, and decimals
  let cleaned = value.replace(/[^0-9.,]/g, "");

  // Fix multiple decimals (keep only the first)
  const parts = cleaned.split(".");
  if (parts.length > 2) {
    cleaned = parts[0] + "." + parts.slice(1).join("");
  }

  // Dynamically limit decimal digits
  if (parts[1]?.length > decimals) {
    cleaned = parts[0] + "." + parts[1].slice(0, decimals);
  }

  // Validate numeric format
  const num = Number(cleaned.replace(/,/g, ""));
  if (isNaN(num)) {
    return prevValue || "0.00";
  }

  return cleaned;
}
/**
 * Format number as currency with commas + 2 decimals
 */
export function formatCurrency(value, opts = {}) {
  if (value === "" || value === null || value === undefined) return "0.00";

  const num = Number(String(value).replace(/,/g, ""));
  if (isNaN(num)) return "0.00";

  const decimals = opts.decimals ?? 2; // 👈 default 2, can override

  return num.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    ...(opts.currency ? { style: "currency", currency: "USD" } : {}),
  });
}

/*

formatCurrency(2500000, { currency: true })  // $2,500,000.00
formatCurrency(2500000)                      // 2,500,000.00
*/

/**
 * Format a date as MM/DD/YYYY for display (e.g. estimated closing date).
 * Matches on the "YYYY-MM-DD" prefix directly rather than going through
 * `new Date(...)` first, since parsing a bare "YYYY-MM-DD" string as UTC
 * and then reading local month/day/year back out of it can shift the date
 * by a day depending on the viewer's timezone — this sidesteps that.
 * Falls back to `new Date(value)` for any other input shape.
 */
export function formatDateMDY(value) {
  if (!value) return "—";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return `${match[2]}/${match[3]}/${match[1]}`;
  const d = new Date(value);
  if (isNaN(d)) return value;
  return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}/${d.getFullYear()}`;
}

/*

export function formatCurrency(value) {
  if (value == null || value === "") return "-";
  return Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


export function formatNumber(value) {
  if (value == null || value === "") return "-";
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
*/